import React, { Component } from 'react';
import './App.css';
import Header from './components/Header/Header.js';
import Main from './components/Main/Main.js';
import Footer from './components/Footer/Footer.js';
import Social from './components/Social/Social.js';
import fontawesome from '@fortawesome/fontawesome';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import brands from '@fortawesome/fontawesome-free-brands';
 
fontawesome.library.add(brands);

class App extends Component {
  constructor() {
    super();
    this.state = {
      work: []
    }
  }

  render() {
    return (
      <div className="App">
        <Header />
        <Social />
        <Main />
        <Footer />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js